// Career.jsx

import "./Career.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const Career = ({ dark }) => {
  return (
    <div className={`career-page ${dark ? "dark" : "light"}`}>
      <Helmet>
        <title>Careers at FadaSports - Join Our Team</title>
        <meta name="description" content="Join the FadaSports team. We are hiring engineers, designers, writers, analysts, and sports enthusiasts to build the future of sports intelligence." />
        <meta name="keywords" content="careers, jobs, hiring, employment, sports jobs, tech jobs, engineering" />
        <meta name="author" content="FadaSports" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Careers at FadaSports" />
        <meta property="og:description" content="Build the future of sports intelligence at FadaSports. Explore career opportunities." />
        <meta property="og:image" content="https://fadasports.com/static/media/mobilelogo.d0257d49e02d3094cce0.png" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="FadaSports" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@FadaSports" />
      </Helmet>

      <section className="career-hero">

        <div className="career-overlay">

          <span className="career-badge">
            Careers at FadaSports
          </span>

          <h1>
            Build The Future Of <span>Sports Intelligence</span>
          </h1>

          <p>
            At FadaSports, we are building a next generation sports media,
            analytics, and statistics platform designed for modern sports
            audiences. We combine technology, storytelling, data, design,
            and innovation to create experiences that help fans understand
            sports on a deeper level.
          </p>

          <p>
            We are always looking for ambitious thinkers, creators,
            engineers, analysts, writers, designers, and sports enthusiasts
            who want to help shape the future of sports intelligence across
            Africa and beyond.
          </p>

          <div className="career-actions">

            <a href="mailto:careers@fadasports.com">
              <button className="career-primary-btn">
                Apply Now
              </button>
            </a>

            <Link to="/about">
              <button className="career-secondary-btn">
                Learn About Us
              </button>
            </Link>

          </div>

        </div>

      </section>

      <section className="career-section">

        <div className="career-section-header">
          <h2>Why Join FadaSports?</h2>

          <p>
            We are building more than a sports platform. We are creating
            an ecosystem where technology, analytics, media, and sports
            culture connect in smarter ways.
          </p>
        </div>

        <div className="career-grid">

          <div className="career-card">
            <h3>Innovation Driven</h3>

            <p>
              Work on modern sports products, analytics systems,
              live experiences, and intelligent digital platforms.
            </p>
          </div>

          <div className="career-card">
            <h3>Global Sports Vision</h3>

            <p>
              Help shape a platform designed to serve sports fans,
              creators, analysts, and communities worldwide.
            </p>
          </div>

          <div className="career-card">
            <h3>Creative Freedom</h3>

            <p>
              We value bold ideas, experimentation, problem solving,
              and fresh thinking across every department.
            </p>
          </div>

          <div className="career-card">
            <h3>Growth Opportunities</h3>

            <p>
              Grow your career while building meaningful products
              within a fast evolving sports ecosystem.
            </p>
          </div>

        </div>

      </section>

      <section className="career-openings">

        <div className="career-section-header">
          <h2>Areas We Hire For</h2>

          <p>
            We are interested in talented individuals across multiple
            disciplines within sports media and technology.
          </p>
        </div>

        <div className="career-role-grid">

          <div className="career-role-box">
            <h3>Engineering & Development</h3>

            <ul>
              <li>Frontend Engineering</li>
              <li>Backend Development</li>
              <li>Mobile App Development</li>
              <li>API & Infrastructure</li>
              <li>Platform Architecture</li>
            </ul>
          </div>

          <div className="career-role-box">
            <h3>Sports Media & Content</h3>

            <ul>
              <li>Sports Journalism</li>
              <li>Football Writers</li>
              <li>Content Strategy</li>
              <li>Video Production</li>
              <li>Editorial Operations</li>
            </ul>
          </div>

          <div className="career-role-box">
            <h3>Data & Analytics</h3>

            <ul>
              <li>Sports Data Analysis</li>
              <li>Performance Research</li>
              <li>Statistical Modeling</li>
              <li>Data Visualization</li>
              <li>Insights & Intelligence</li>
            </ul>
          </div>

          <div className="career-role-box">
            <h3>Design & Product</h3>

            <ul>
              <li>UI/UX Design</li>
              <li>Product Design</li>
              <li>Creative Branding</li>
              <li>User Experience Research</li>
              <li>Interaction Design</li>
            </ul>
          </div>

        </div>

      </section>

      <section className="career-culture">

        <div className="career-culture-left">

          <h2>Our Culture</h2>

          <p>
            FadaSports is built around curiosity, creativity, teamwork,
            discipline, and passion for sports. We believe great products
            come from people who genuinely care about the experiences they
            create.
          </p>

          <p>
            We encourage collaboration across teams, open communication,
            continuous learning, and a culture where ideas can come from
            anyone.
          </p>

          <p>
            Whether you are a developer, analyst, writer, designer, or
            strategist, your work at FadaSports contributes directly to
            shaping how sports are understood and experienced digitally.
          </p>

        </div>

        <div className="career-culture-right">

          <div className="culture-box">

            <div className="culture-item">
              <strong>Smart Collaboration</strong>
              <span>Cross functional teamwork and innovation.</span>
            </div>

            <div className="culture-item">
              <strong>Modern Technology</strong>
              <span>Building scalable sports experiences.</span>
            </div>

            <div className="culture-item">
              <strong>Creative Thinking</strong>
              <span>Fresh ideas and bold experimentation.</span>
            </div>

            <div className="culture-item">
              <strong>Sports Passion</strong>
              <span>A deep love for the global sports culture.</span>
            </div>

          </div>

        </div>

      </section>

      <section className="career-contact">

        <h2>Interested In Joining Us?</h2>

        <p>
          We are continuously looking for talented individuals who want
          to help redefine sports media, analytics, and digital sports
          experiences.
        </p>

        <p>
          Send your CV, portfolio, or introduction to:
        </p>

        <a
          href="mailto:careers@fadasports.com"
          className="career-email"
        >
          careers@fadasports.com
        </a>

      </section>

    </div>
  );
};

export default Career;